import { Tab } from '@mui/material'
import { styled } from '@mui/material/styles'
import { GRAY_COLORS, INFO_COLORS } from 'asterX-UI/colors.constant'
import { secondaryB } from 'lib/constants/colors'

const AsterTab = styled(Tab)(({ theme }) => ({
  textTransform: 'none',
  paddingLeft: '16px',
  paddingRight: '16px',
  paddingTop: '12px',
  paddingBottom: '12px',
  fontSize: '14px',
  height: '41px',
  borderRadius: '8px 8px 0 0',
  fontWeight: 600,
  color: GRAY_COLORS[500],
  opacity: 1,
  minWidth: 'max-content',
  '&:hover': {
    backgroundColor: secondaryB,
    borderBottom: `1px solid ${INFO_COLORS[600]}`,
    color: INFO_COLORS[600]
  },
  '&.Mui-selected': {
    borderBottom: `3px solid ${INFO_COLORS[600]}`,
    color: INFO_COLORS[600],
    fontWeight: 700,
    '&:hover': {
      backgroundColor: secondaryB
    }
  },
  '&:focus': {
    color: INFO_COLORS[600]
  }
}))

export default AsterTab
